import { RegionPermissions, RegionFormParams } from './region'

export enum Access {
  'NO_ACCESS' = 'no_access',
  'READ' = 'read',
  'WRITE' = 'write',
}

export type ProjectPermissions = {
  id: number
  name: string
  access: string
}

export type PredictiveModelPermissions = {
  id: number
  name: string
  access: string
}

export type LayerPermissions = {
  id: number
  name: string
  access: boolean
}

export type UserPermissions = {
  projects: ProjectPermissions[]
  layers: LayerPermissions[]
  predictiveModels: PredictiveModelPermissions[]
  area: RegionPermissions
}

export type UserPermissionsUpdateParams = {
  projects?: ProjectPermissions[]
  layers?: LayerPermissions[]
  predictiveModels?: PredictiveModelPermissions[]
  area?: RegionFormParams
}
